export default __webpack_public_path__ + "static/media/ta.3e39e3ad.jpg";